const profileTypes = {
    GET_PROFILE_REQUEST: 'GET_PROFILE_REQUEST',
    GET_PROFILE: 'GET_PROFILE',
    SET_USER_ONLINE_STATUS: 'SET_USER_ONLINE_STATUS',
    SET_USER_ONLINE_STATUS_REQUEST: 'SET_USER_ONLINE_STATUS_REQUEST',
    ERROR: 'ERROR',
}

export default profileTypes;
